import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: 'DE', // set locale
    fallbackLocale: 'EN', // set fallback locale
    silentFallbackWarn: true,
    silentTranslationWarn: true,
    messages: {}, // set locale messages
});

export default i18n;